import { render, staticRenderFns } from "./PscYearlyOverview.vue?vue&type=template&id=4cf665ec&scoped=true&"
import script from "./PscYearlyOverview.vue?vue&type=script&lang=js&"
export * from "./PscYearlyOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf665ec",
  null
  
)

export default component.exports